<template>
  <TrustPilotCarousel />
</template>

<script lang="ts">
import TrustPilotCarousel from '~/components/molecules/TrustPilot/TrustPilotCarousel.vue';

export default defineComponent({
  name: 'TrustPilotCarouselCms',
  components: {
    TrustPilotCarousel,
  },
});
</script>
